import { isObject, toPairs, omit, toArray } from 'lodash';
/*
const Components = require('./components.js');
const Util = require('./util.js');
const COLORS = [ 0xCF372B, 0xDE873A, 0x5C8D23, 0x00D6E8, 0x00C2F9, 0xF7DCAF, 0xE7E3D5, 0xE2F3CA]
*/

function makeDebug(gameobjects) {
  let DEBUG_TEXTS = {};
  let DEBUG_TRANSFORMS = {};
  let didDebug = false;
  let DEBUG_LINES = {};
  let DEBUG_SYSTEMS = {};
  let FRAME_NUM = 0;

  function startSystem(systemName, total, subCategory) {
    if (!gameobjects.DEBUG_DRAW) {
      return;
    }
    let name = systemName;
    if (subCategory) {
      name += '-' + subCategory;
    }
    DEBUG_SYSTEMS[name] = {
      //t:new Date().getTime(),
      t:performance.now(),
      total:total
    }
  }
  function clean(root, x) {
    const k = x[0];
    let v=  x[1];
    if (k.indexOf('_') === 0) {
      return;
    }
    if (!isObject(v)) {
      root[k] = v;
    } else {
      const o = {};
      toPairs(v).forEach( (x) => {
        clean(o, x);
      });
      root[k] = o;
    }

  }

  function getDebugInfoForEntity(entity) {
    const o = {};
    toPairs(entity).forEach( (x) => {
      clean(o, x);
    });

    return o
  }


  function addComponent(ent, component) {
    if (!gameobjects.DEBUG_DRAW) {
      return;
    }
    const cleanedComponent = omit(component, ['text','description','depth','parent','slots','isPrefab','numChildren','closed','description','expose','disabled']);
    addDebugLine(ent, `<${ent.id}> add component: ${cleanedComponent.type}`);
    //addDebugLine(ent, `<${ent.id}> ent: ` + JSON.stringify(
      //getDebugInfoForEntity(ent),
      //0,
      //2
    //));
  }

  function stopSystem(systemName, categoryName) {
    if (!gameobjects.DEBUG_DRAW) {
      return;
    }
    let name = systemName;
    if (categoryName) {
      name += '-' + categoryName;
    }
    //DEBUG_SYSTEMS[name].time = new Date().getTime() - DEBUG_SYSTEMS[name].t;
    DEBUG_SYSTEMS[name].time = performance.now() - DEBUG_SYSTEMS[name].t;
  }

  function selectTransform(gameobjects, ent) {
    //gameobjects.this.$store.state.eventbus.bus.$emit('debugTransform', ent);
  }

  function box2dDebug(gameobjects, dt) {
    gameobjects.graphics.clear();
    //gameobjects.graphics.lineStyle(1, 0xffffff);
    //gameobjects.graphics.moveTo(0,0);
    //gameobjects.graphics.lineTo(100,100);
    gameobjects.box2d_world.DrawDebugData();
  }

  function addDebugLine(ent, line) {
    if (!gameobjects.DEBUG_DRAW) {
      return;
    }
    //console.log('debugline', ent, line);
    const extraArgs = toArray(arguments).slice(2).map( (arg) => {
      if (isObject(arg)) {
        return JSON.stringify(getDebugInfoForEntity(arg),0,2);
      } else {
        return arg;
      }
    }).join(" ");
    const uuid = ent.uuid.uuid;
    if (!DEBUG_LINES[uuid]) {
      DEBUG_LINES[uuid] = [];
    }
    DEBUG_LINES[uuid].push(line + ' ' + extraArgs);
  }

  function updateDebug(gameobjects, dt) {
    const coords = gameobjects.coords;
    if (!gameobjects.DEBUG_DRAW) {
      if (didDebug) {
        toPairs(DEBUG_TEXTS).forEach( (d) => {
          gameobjects.app.stage.removeChild(d[1]);
        });
        toPairs(DEBUG_TRANSFORMS).forEach( (d) => {
          gameobjects.app.stage.removeChild(d[1]);
        });
        //gameobjects.this.$store.state.eventbus.bus.$emit('frameEnd', {
          //systems:{},
          //frameNum:FRAME_NUM
        //});
      }
      didDebug = false;
      DEBUG_TEXTS = {};
      DEBUG_TRANSFORMS = {};
      DEBUG_LINES = {};
      DEBUG_SYSTEMS = {};

      return;
    }
    didDebug = true;

    function getText(ent) {
      let lines = toPairs(ent.uuid.state).map( (x) => {
          return x[0] + ': ' + x[1];
      });
      lines = lines.concat(DEBUG_LINES[ent.uuid.uuid] || []);

      return lines.join("\n");
    }
    /*
    const ents = gameobjects.entities.queryComponents([Components.Transform]);
    const total = ents.length;
    for (var i = 0; i < total; i++) {
      const ent = ents[i];
      const uuid = ent.uuid.uuid;
      const width = coords.dimToScreenX(ent.transform.scalex);
      const height = coords.dimToScreenY(ent.transform.scaley);

      if (!DEBUG_TRANSFORMS[uuid]) {
        let shape = new PIXI.Graphics();
        shape.beginFill(shuffle(COLORS)[0]);
        shape.drawRect(0, 0, width, height);
        shape.endFill();
        shape.pivot.set(width*ent.transform.anchorx,height*ent.transform.anchory);
        shape.zIndex = 100;
        gameobjects.app.stage.addChild(shape);
        shape.interactive = true;

        shape.on('pointerup', selectTransform.bind(null, gameobjects, ent));

        DEBUG_TRANSFORMS[uuid] = shape;
      }
      const shape = DEBUG_TRANSFORMS[uuid];
      shape.x = coords.toScreenX(ent.transform.x + ent.transform.dx);
      shape.y = coords.toScreenY(ent.transform.y + ent.transform.dy);
      shape.rotation = ent.transform.rotation;
      if (gameobjects.debugEntities.indexOf(ent) !== -1) {
        shape.alpha = 0.8;
      } else {
        shape.alpha = 0.4;
      }

      if (!DEBUG_TEXTS[uuid] && gameobjects.debugEntities.indexOf(ent) !== -1) {
        const text = new PIXI.Text('', {
          fontWeight: 'bold',
          fontSize: 10,
          fontFamily: 'Arial',
          fill: '#ffffff',
          align: 'center',
          stroke: '#000000',
          strokeThickness: 1
        });
        DEBUG_TEXTS[uuid] = text;
        text.anchor.set(0.5);
        gameobjects.app.stage.addChild(text);
      }

      const t = DEBUG_TEXTS[uuid];
      if (t) {
        t.text = ent.uuid.uuid;
        t.x = gameobjects.coords.toScreenX(ent.transform.x);
        t.y = gameobjects.coords.toScreenY(ent.transform.y);
        t.zIndex = 99;
        gameobjects.this.$store.state.eventbus.bus.$emit('debugLines', {uuid:uuid, log:DEBUG_LINES[uuid]});
      }

     
    }
    */

    FRAME_NUM++;
    //console.log('emit stuff');
    let totals = [];
    toPairs(gameobjects.entities._tags).forEach( (x) => {
      if (x[1].length) {
        totals.push({
          name:x[0],
          total:x[1].length
        });
      }
    });
    //console.log('totals', totals);
    //console.log(FRAME_NUM,'----------------------------------------');
    gameobjects.entities._entities.forEach( (e) => {
      //console.log(e.id, e._tags.join(","), e.uuid.uuid)
    });
    //gameobjects.$store.state.eventbus.bus.$emit('frameEnd', {
      //systems:DEBUG_SYSTEMS,
      //totalEntities:gameobjects.entities._entities.length,
      //totals,
      //frameNum:FRAME_NUM
    //});

    const uuids = gameobjects.debugEntities.map( (e) => {
      return e.uuid.uuid;
    });
    toPairs(DEBUG_TEXTS).forEach( (x) => {
      const k = x[0];
      const v = x[1];
      if (uuids.indexOf(k) === -1) {
        //gameobjects.this.$store.state.eventbus.bus.$emit('debugLines', {uuid:k, log:[]});
        gameobjects.app.stage.removeChild(v);
      }
    });


    DEBUG_LINES = {};
    DEBUG_SYSTEMS = {};
  }

  // function to measure box2d memory usage
  function checkBox2DMemory() {
    if (gameobjects.box2DWasm) {
      return -1;
    }
    const box2d = gameobjects.Box2D;
    let ptrs = [];
    let total = 0;
    let counts = {};
    let count = 0;
    let size = 1024 * 1024;

    while (size >= 1) {
      try {
        ptrs.push(box2d._malloc(size));
        total += size;
        count++;

      } catch (e) {
        counts[size] = count;
        size /= 2;
        count = 0;
      }
    }

    try {
      for (var i in ptrs) {
        box2d._free(ptrs[i]);
      }
    } catch (e) {
      //console.logToUser(e);
    }

    //for (var s in counts) {
    //    console.logToUser(counts[s] + " of size " + s);
    //}
    return (128 * 1024 * 1024) - total;
  }

  return {
    box2dDebug,
    addDebugLine,
    startSystem,
    stopSystem,
    addComponent,
    checkBox2DMemory,
    updateDebug
  }
}


export default makeDebug;

